import common from './en/common';
import nav from './en/nav';
import footer from './en/footer';
import home from './en/home';
import catalog from './en/catalog';
import product from './en/product';
import cart from './en/cart';
import checkout from './en/checkout';
import auth from './en/auth';
import account from './en/account';
import orders from './en/orders';
import articles from './en/articles';
import faq from './en/faq';
import legal from './en/legal';
import errors from './en/errors';

export default {
  common,
  nav,
  footer,
  home,
  catalog,
  product,
  cart,
  checkout,
  auth,
  account,
  orders,
  articles,
  faq,
  legal,
  errors,
};
